import React from "react";
import NavBar from "../NavBar";
import ApiContentBlank from "./ApiContentBlank";
import Footer from "../Footer";

function API() {
  return (
    <div className="p-3">
      {/*Add title and metadata */}
      <title>Humanize Texts, AI Detector & Paraphraser API</title>
      <meta name="robots" content="index, follow"></meta>
      <meta
        name="description"
        content="Text humanizer, AI detector, Paraphraser API"
      ></meta>
      <meta
        name="keywords"
        content="api,cheap api,humanizer api,ai detector api,paraphraser api,"
      ></meta>
      {/* NavBar component */}
      <NavBar />
      {/* API Content Blank */}
      <ApiContentBlank />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default API;
